import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Context } from "../../Reducers/Store";
import { arrayFromResponse } from "../../utils/arrayResponse";

function saudacao() {
  const h = new Date().getHours();
  if (h < 12) return "Bom dia";
  if (h < 18) return "Boa tarde";
  return "Boa noite";
}

export default function Dashboard() {
  const [state] = useContext(Context);
  const navigate = useNavigate();
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const podeCriarEventos = !!state?.profile?.podeCriarEventos;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/evento/meus-eventos`)
      .then((res) => setEventos(arrayFromResponse(res.data)))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const agora = new Date();
  const ativos = eventos.filter((e) => e.isActive).length;
  const proximos = eventos.filter((e) => new Date(e.dataDoEvento) > agora).length;
  const passados = eventos.filter((e) => new Date(e.dataDoEvento) <= agora).length;

  const proximosEventos = eventos
    .filter((e) => new Date(e.dataDoEvento) > agora)
    .sort((a, b) => new Date(a.dataDoEvento) - new Date(b.dataDoEvento))
    .slice(0, 5);

  const formatarData = (data) =>
    new Date(data).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "America/Sao_Paulo",
    });

  const diasRestantes = (data) => {
    const diff = Math.ceil((new Date(data) - agora) / (1000 * 60 * 60 * 24));
    if (diff === 0) return "Hoje";
    if (diff === 1) return "Amanhã";
    return `em ${diff} dias`;
  };

  const stats = [
    {
      titulo: "Total de Eventos",
      valor: loading ? "—" : eventos.length,
      iconBg: "from-indigo-500 to-indigo-700",
      numColor: "text-indigo-600",
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      titulo: "Eventos Ativos",
      valor: loading ? "—" : ativos,
      iconBg: "from-emerald-500 to-emerald-700",
      numColor: "text-emerald-600",
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      titulo: "Próximos Eventos",
      valor: loading ? "—" : proximos,
      iconBg: "from-violet-500 to-violet-700",
      numColor: "text-violet-600",
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      titulo: "Eventos Realizados",
      valor: loading ? "—" : passados,
      iconBg: "from-slate-500 to-slate-700",
      numColor: "text-slate-600",
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      ),
    },
  ];

  return (
    <div className="w-full min-w-0">

      {/* Welcome banner */}
      <div
        className="rounded-2xl p-6 sm:p-8 mb-8 relative overflow-hidden"
        style={{ background: "linear-gradient(135deg, #1e1b4b 0%, #3b0764 100%)" }}
      >
        {/* Decorative circles */}
        <div className="absolute -top-8 -right-8 w-48 h-48 rounded-full opacity-10" style={{ background: "radial-gradient(circle,#a78bfa,transparent)" }} />
        <div className="absolute -bottom-12 -left-6 w-40 h-40 rounded-full opacity-10" style={{ background: "radial-gradient(circle,#c4b5fd,transparent)" }} />

        <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-purple-300 text-sm font-medium mb-1">{saudacao()},</p>
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-1">
              {state?.profile?.primeiroNome}! 👋
            </h1>
            <p className="text-purple-300 text-sm">Aqui está a visão geral dos seus eventos.</p>
          </div>
          {podeCriarEventos && (
            <button
              onClick={() => navigate("/eventos/novo")}
              className="self-start sm:self-auto flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold text-indigo-900 bg-white hover:bg-purple-50 transition shadow-lg shadow-purple-900/30 shrink-0"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
              </svg>
              Novo Evento
            </button>
          )}
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {stats.map((s) => (
          <div
            key={s.titulo}
            className="bg-white rounded-2xl p-5 shadow-sm ring-1 ring-slate-200/60 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`p-2.5 rounded-xl bg-gradient-to-br ${s.iconBg} shadow-sm`}>
                {s.icon}
              </div>
            </div>
            <p className={`text-3xl font-extrabold ${s.numColor} leading-none mb-1`}>{s.valor}</p>
            <p className="text-xs font-medium text-slate-500">{s.titulo}</p>
          </div>
        ))}
      </div>

      {/* Próximos eventos */}
      <div className="bg-white rounded-2xl shadow-sm ring-1 ring-slate-200/60 overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-violet-500" />
            <h2 className="text-base font-bold text-slate-800">Próximos Eventos</h2>
            {!loading && proximos > 0 && (
              <span className="ml-1 px-2 py-0.5 text-xs font-semibold bg-violet-100 text-violet-700 rounded-full">
                {proximos}
              </span>
            )}
          </div>
          <button
            onClick={() => navigate("/eventos")}
            className="text-sm font-medium text-violet-600 hover:text-violet-800 transition-colors"
          >
            Ver todos →
          </button>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="w-8 h-8 border-2 border-violet-300 border-t-violet-600 rounded-full animate-spin" />
          </div>
        ) : proximosEventos.length === 0 ? (
          <div className="text-center py-16 px-6">
            <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-slate-500 font-medium mb-1">Nenhum evento futuro</p>
            <p className="text-slate-400 text-sm mb-4">
              {podeCriarEventos ? "Crie seu primeiro evento e comece a receber confirmações." : "Eventos compartilhados aparecerão aqui quando houver próximos eventos."}
            </p>
            {podeCriarEventos && (
              <button
                onClick={() => navigate("/eventos/novo")}
                className="px-5 py-2 text-sm font-semibold rounded-xl text-white transition"
                style={{ background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}
              >
                Criar evento
              </button>
            )}
          </div>
        ) : (
          <div className="divide-y divide-slate-100">
            {proximosEventos.map((evento, idx) => {
              const dias = diasRestantes(evento.dataDoEvento);
              const isUrgente = dias === "Hoje" || dias === "Amanhã";
              return (
                <div
                  key={evento.id}
                  onClick={() => navigate(`/eventos/${evento.id}`)}
                  className="flex items-center gap-4 px-6 py-4 hover:bg-slate-50 cursor-pointer transition-colors group"
                >
                  {/* Order indicator */}
                  <div
                    className="w-9 h-9 rounded-xl flex items-center justify-center text-sm font-bold shrink-0"
                    style={{ background: idx === 0 ? "linear-gradient(135deg,#8b5cf6,#6d28d9)" : "#f1f5f9", color: idx === 0 ? "white" : "#64748b" }}
                  >
                    {idx + 1}
                  </div>

                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-slate-800 truncate group-hover:text-violet-700 transition-colors">
                      {evento.nome}
                    </p>
                    <p className="text-xs text-slate-500 truncate flex items-center gap-1 mt-0.5">
                      <svg className="w-3 h-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {evento.nomeEspaco ? `${evento.nomeEspaco} — ${evento.localizacao}` : evento.localizacao}
                    </p>
                  </div>

                  <div className="flex flex-col items-end gap-1 shrink-0">
                    <span className={`px-2.5 py-0.5 text-xs font-semibold rounded-full ${
                      isUrgente ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600"
                    }`}>
                      {dias}
                    </span>
                    <span className="text-xs text-slate-400">{formatarData(evento.dataDoEvento)}</span>
                  </div>

                  <svg className="w-4 h-4 text-slate-300 group-hover:text-violet-500 transition-colors shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
